export const Title = "South China Morning Post";
export const DefaultTitleTemplate = `%s | ${Title}`;
